// src/i18n/translations/tr.js
const translations = {
  brand: "Marka",
  category: "Kategori",
  type: "Tip",
  cargo_capacity: "Bagaj Hacmi",
  seats: "Koltuk",
  created_at: "Oluşturulma Tarihi",
  updated_at: "Güncellenme Tarihi",
  id: "ID",
  user_id: "Kullanıcı ID",
  invoices: "Faturalar",
  vehicle: "Araçlarım",
  transfer_all: "Tüm Yolculuklara Genel Bakış",
  transfer_new: "Yeni Yolculuklar",
  transfer_assign: "Sürücü ata",
  vatIdLabel: "Müşteri KDV kimlik no.",
  bookingAs: "Rezervasyonu şu olarak yapıyorum",
  privatePerson: "Bireysel",
  companyOption: "Şirket",
  companyName: "Şirket adı",
  vatIdOptional: "KDV kimlik no. (isteğe bağlı)",
  vatIdInvalid: "Geçersiz KDV kimlik no. (örn. DE123456789)",
  receiptHint: "Makbuz/fatura için",
  transfer_close: "Tamamlanacaklar",
  completeTrip: "Tamamla",
  completeTripConfirm: "Yolculuk tamamlansın mı? Müşteri teşekkür e-postasını ve makbuzu alır; ödeme ödendi olarak işaretlenir.",
  instantConfirmed: "Anında onay",
  ratingFilter: "Puan",
  allRatings: "Tüm puanlar",
  starsAndUp: "yıldız ve üzeri",
  instantHint: "Anında onay: rezervasyonunuz hemen onaylanır",
  transfer_today: "Bugünkü Yolculuklar",
  transfer_tomorrow: "Yarınki Yolculuklar",
  transfer_current: "Devam Eden Yolculuklar",
  transfer_storno: "İptal Edilen Yolculuklar",
  transfer_reklamiert: "Şikayet Edilen Yolculuklar",
  transfer_noshow: "Gelmeyen Yolculuklar",
  transfer_finished: "Tamamlanan Yolculuklar",
  transfer_all_admin: "Tüm Yolculuklara Genel Bakış",
  transfer_new_admin: "Yeni Yolculuklar",
  transfer_today_admin: "Bugünkü Yolculuklar",
  transfer_tomorrow_admin: "Yarınki Yolculuklar",
  transfer_current_admin: "Devam Eden Yolculuklar",
  transfer_storno_admin: "İptal Edilen Yolculuklar",
  transfer_reklamiert_admin: "Şikayet Edilen Yolculuklar",
  transfer_noshow_admin: "Gelmeyen Yolculuklar",
  transfer_finished_admin: "Tamamlanan Yolculuklar",
  driver: "Sürücülerim",
  first_name: "Ad",
  last_name: "Soyad",
  pickup_datetime: "Alış Tarihi / Alış Saati",
  status: "Durum",
  total_price: "Toplam Fiyat",
  route: "Nereden → Nereye",
  payment_method: "Ödeme Yöntemi",
  currency: "Para Birimi",
  invoice_status: "Fatura",
  data: "Şirketim",
  company_active: "Kullanıcı Onaylandı",
  logo: "Şirket Logosu Yükle",
  company_name: "Şirket Adı",
  company_legal_form: "Şirket Türü",
  company_register_number: "Ticaret Sicil Numarası",
  company_street: "Adres",
  company_zip: "Posta Kodu",
  company_country: "Ülke",
  company_city: "Şehir",
  company_tax_number: "Vergi Numarası",
  company_vat_id: "KDV Numarası",
  company_phone: "Telefon Numarası (İş)",
  company_email: "E-posta Adresi (İş)",
  company_website: "Web Sitesi",
  licence: "İşletme Ruhsatı Yükle",
  company_licence: "İşletme Ruhsatı Mevcut mu?",
  company_licence_expiration: "İşletme Ruhsatı Son Kullanma Tarihi?",
  prices: "Kademeli Fiyatlar",
  bis10km: "10KM'ye kadar hesaplanan km fiyatı",
  bis20km: "20KM'ye kadar hesaplanan km fiyatı",
  bis50km: "50KM'ye kadar hesaplanan km fiyatı",
  bis100km: "100KM'ye kadar hesaplanan km fiyatı",
  ab100km: "100KM'den itibaren hesaplanan km fiyatı",
  citys: "Hizmet Verilen Şehirler",
  getpartner: "Partner Ol",
  partnerlogin: "Partner Girişi",
  editbooking: "Rezervasyonu Yönet",
  contact: "İletişim",
  booknow: "Şimdi Rezervasyon Yap",
  oneway: "Sadece Gidiş",
  roundtrip: "Gidiş-Dönüş",
  flughafentransfer: "Havalimanı Transferi",
  ConvenientAndOnTime: "Zamanında. Konforlu.",
  yourTransfer: "Transferiniz.",
  bnHeadline: "Bugün nereye gitmek istersiniz?",
  bnSub: "Sabit fiyatlı havalimanı transferiniz – birkaç tıkla rezerve edin",
  bnPopular: "Popüler güzergahlar",
  bnRoute1: "Köln → Düsseldorf Havalimanı",
  bnRoute2: "Essen → Düsseldorf Havalimanı",
  bnRoute3: "Düsseldorf → Köln/Bonn Havalimanı",
  bnRoute4: "Bonn → Frankfurt Havalimanı",
  moBestRated: "En iyi puan",
  moRecommended: "Önerilen",
  moAll: "Tümü",
  moDetails: "Ayrıntılar",
  moLess: "Daha az",
  moOffersN: "{n} teklif",
  moOfferOne: "1 teklif",
  moFrom: "başlangıç",
  moPicksTitle: "Sizin için seçtiklerimiz",
  moCheapest: "En ucuz",
  guideHello: "Merhaba, nereye gidiyoruz?",
  guideTitle1: "Transferiniz",
  guideTitle2: "3 adımda",
  guideStepRoute: "Rota",
  guideStepDate: "Tarih",
  guideStepOffer: "Teklif",
  guideRoute: "Güzergahınız",
  guideWhen: "Ne zaman?",
  guideToday: "Bugün",
  guideTomorrow: "Yarın",
  guidePick: "Tarih",
  guidePickupTime: "Alış saati",
  guideReturn: "Dönüş yolculuğu ekle",
  uberHeadline: "Transferiniz – her yere",
  privateTransferDescription: "Sabit fiyatlarla özel şoför hizmeti – kapıdan kapıya, sürprizsiz.",
  bookRide: "Yolculuk Rezervasyonu",
  destination: "Varış Noktası",
  enterDestinationAddress: "Varış adresini girin",
  returnTrip: "Dönüş Yolculuğu",
  outboundTrip: "Gidiş Yolculuğu",
  paymentMethods: "Ödeme Yöntemleri",
  loading: "Yükleniyor…",
  showOffers: "Teklifleri Göster",
  rides: "Yolculuklar",
  customerRating: "Müşteri Değerlendirmesi",
  vehicles: "Araçlar",
  support: "Destek",
  recentSearches: "Son Aramalar",
  departure: "Kalkış",
  enterStartAddress: "Başlangıç adresini girin",
  swapAddresses: "Adresleri Değiştir",
  whyGoTransfer24: "Neden GoTransfer24",
  clearBenefits: "Net Avantajlar",
  atAGlance: "bir bakışta.",
  fairFixedPricesTitle: "Adil Sabit Fiyatlar",
  fairFixedPricesDescription: "Taksimetre yok, risk yok. Fiyat rezervasyondan önce belirlenir – şeffaf ve garantili.",
  bookedIn60SecondsTitle: "60 Saniyede Rezervasyon",
  bookedIn60SecondsDescription: "Başlangıç, varış, araç – tamam. Kayıt yok, evrak işi yok, bekleme yok.",
  flexiblePaymentTitle: "Esnek Ödeme",
  flexiblePaymentDescription: "PayPal, kredi kartı veya sürücüye nakit. Size en uygun olanı siz seçin.",
  verifiedDriversTitle: "Doğrulanmış Sürücüler",
  verifiedDriversDescription: "Tüm sürücüler lisanslı ve kişisel olarak doğrulanmıştır. Dakiklik ve profesyonellik garantidir.",
  available247Title: "7/24 Hizmet",
  available247Description: "Sabah 4'te erken uçuş mu var? Sorun değil. Günün her saati sizin için buradayız.",
  luggageExtrasTitle: "Bagaj & Ekstralar",
  luggageExtrasDescription: "Çocuk koltuğu, fazla bagaj, evcil hayvan – hepsi rezerve edilebilir. Ödeme sırasında ekleyin.",
  chooseRoute: "Güzergah Seçin",
  selectTripType: "Tek yön veya gidiş-dönüş seçin",
  enterAddresses: "Başlangıç ve varış adresini girin",
  setDateTime: "Tarih & Saat Belirleyin",
  chooseVehicle: "Araç Seçin",
  compareOffersPrices: "Teklifleri ve Fiyatları Karşılaştırın",
  selectVehicle: "Uygun Aracı Seçin",
  enterDetails: "Detayları Girin",
  enterPassengerDetails: "Yolcu Bilgilerini Girin",
  addFlightInformation: "Uçuş Bilgilerini Ekleyin",
  selectExtras: "Ekstra ve Ek Hizmetleri Seçin",
  confirmation: "Onay",
  selectPaymentMethod: "Ödeme Yöntemi Seçin",
  receiveBookingConfirmation: "Rezervasyon Onayı Alın",
  businessAirportTransfer: "Business Havalimanı Transferi",
  economyAirportTransfer: "Ekonomi Havalimanı Transferi",
  luxuryAirportTransfer: "Lüks Havalimanı Transferi",
  vipSprinterTransfer: "VIP Sprinter Transfer",
  faqPriceQuestion: "GoTransfer24 ile havalimanı transferi ne kadar tutar?",
  faqPriceAnswer: "Fiyat, güzergaha, tarihe ve seçilen araç sınıfına bağlıdır ve rezervasyonu tamamlamadan önce sabit fiyat olarak gösterilir. Trafik, gece yolculuğu veya normal bagaj için ek ücret alınmaz.",
  faqAdvanceBookingQuestion: "Ne kadar önceden rezervasyon yapmalıyım?",
  faqAdvanceBookingAnswer: "Son dakika rezervasyonlar da mümkündür, ancak özellikle tatillerde veya yoğun seyahat döneminde en az 24 saat önceden rezervasyon yapmanızı öneririz.",
  faqFlightDelayQuestion: "Uçuşum gecikirse ne olur?",
  faqFlightDelayAnswer: "Sorun değil – varış saati canlı olarak takip edilir ve otomatik olarak ayarlanır. Sürücünüz gecikmeden haberdardır ve ek ücret olmadan sizi bekler.",
  faqCancelChangeQuestion: "Rezervasyonumu iptal edebilir veya değiştirebilir miyim?",
  faqCancelChangeAnswer: "Evet, planlanan alıştan 24 saat öncesine kadar değişiklik ve iptaller ücretsizdir.",
  faqChildSeatsQuestion: "Çocuk koltuğu ve engelli erişimli araçlar sunuyor musunuz?",
  faqChildSeatsAnswer: "Evet, farklı yaş gruplarına uygun çocuk koltukları rezervasyon sırasında eklenebilir ve van sınıfımız birçok lokasyonda tekerlekli sandalye erişimine de uygundur.",
  faqPaymentQuestion: "Hangi ödeme yöntemleri kabul ediliyor?",
  faqPaymentAnswer: "Çevrimiçi olarak kart, PayPal, Klarna, fatura veya taksitle ödeme yapabilirsiniz. Yerinde sürücüye doğrudan ödeme de mümkündür.",
  transferServiceDescription: "GoTransfer24, Almanya ve Avrupa genelinde özel havalimanı transferleri için doğrulanmış sürücülerle sizi buluşturur. İster iş seyahati, ister aile tatili, ister şehir turu olsun – sizi güvenilir bir şekilde ve doğrudan havalimanına veya kapınıza kadar götürüyoruz. Sabit fiyatlar, gecikmeler için otomatik uçuş takibi ve bir dakikadan kısa sürede rezervasyon, transferi mümkün olduğunca kolay hale getirir.",
  routePriceCologneDusseldorf: "99 €'dan başlayan fiyatlarla",
  routePriceFrankfurtHeidelberg: "129 €'dan başlayan fiyatlarla",
  routePriceMunichAugsburg: "89 €'dan başlayan fiyatlarla",
  routePriceHamburgLuebeck: "79 €'dan başlayan fiyatlarla",
  routePriceBerlinPotsdam: "69 €'dan başlayan fiyatlarla",
  routePriceStuttgartUlm: "109 €'dan başlayan fiyatlarla",
  popularRoutes: "Popüler Güzergahlar",
  allLocations: "Tüm Lokasyonlar",
  chooseYour: "Havalimanınızı",
  airport_: "seçin.",
  allLocationsOverview: "Tüm Lokasyonlara Genel Bakış",
  locationsDescription: "GoTransfer24, 11 ülkede 26 lokasyonda doğrulanmış partner sürücülerle sizi buluşturur. Her şehrin yerel güzergahlar, terminal bilgileri ve o havalimanına özel sorular içeren kendi sayfası vardır.",
  priceDisclaimer: "* Fiyat, süre ve mesafe yaklaşık değerlerdir ve bağlayıcı bir teklif oluşturmaz.",
  somethingWentWrong: "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
  sustainability: "Sürdürülebilirlik",
  everyRide: "Her yolculukta",
  aTree: "bir ağaç.",
  treePlantingDescription: "Her çevrimiçi ve WhatsApp rezervasyonu için bir ağaç dikiyoruz. Çevre bilincine sahip bir şirket olarak sadece sürdürülebilir hareketliliği desteklemek değil, aynı zamanda çevre korumasına aktif olarak katkıda bulunmak istiyoruz. Desteğiniz için teşekkür ederiz.",
  treesPlanted: "Dikilen Ağaçlar",
  compensated: "Telafi Edildi",
  howItWorks: "Nasıl Çalışır",
  inFourSteps: "4 Adımda",
  toBooking: "rezervasyona.",
  ourStrengths: "Güçlü Yönlerimiz",
  clearAdvantagesWith: "Net Avantajlar",
  freeNonBindingService: "Ücretsiz, bağlayıcı olmayan hizmet",
  punctualPickupsGuaranteed: "Dakik alışlar garanti",
  verifiedDriverNetwork: "Doğrulanmış sürücü ağı",
  upTo70PercentCheaperThanTaxis: "Taksilerden %70'e varan oranda ucuz",
  topRatingsSatisfiedCustomers: "Memnun müşterilerden en yüksek puanlar",
  customerReviews: "Müşteri Yorumları",
  whatOurCustomers: "Müşterilerimiz",
  say: "ne diyor.",
  reviewMarco: "Çok dakik, temiz araç ve güler yüzlü bir sürücü. Tekrar rezervasyon yapacağım.",
  reviewLena: "Rezervasyonu kolay ve taksiden çok daha ucuz. Havalimanı için mükemmel!",
  reviewThomas: "İlk tıklamadan varışa kadar profesyonel hizmet. Kesinlikle tavsiye ederim.",
  supportDescription: "Sorularınız, önerileriniz veya yorumlarınız için nitelikli destek ekibimiz size yardımcı olmaktan mutluluk duyar.",
  germany: "Almanya",
  netherlands: "Hollanda",
  belgium: "Belçika",
  france: "Fransa",
  luxembourg: "Lüksemburg",
  switzerland: "İsviçre",
  austria: "Avusturya",
  czechia: "Çekya",
  poland: "Polonya",
  denmark: "Danimarka",
  turkey: "Türkiye",
  cologne: "Köln",
  dusseldorf: "Düsseldorf",
  frankfurt: "Frankfurt",
  munich: "Münih",
  berlin: "Berlin",
  hamburg: "Hamburg",
  stuttgart: "Stuttgart",
  hannover: "Hannover",
  amsterdam: "Amsterdam",
  eindhoven: "Eindhoven",
  brussels: "Brüksel",
  charleroi: "Charleroi",
  paris: "Paris",
  luxembourgCity: "Lüksemburg",
  zurich: "Zürih",
  geneva: "Cenevre",
  basel: "Basel",
  vienna: "Viyana",
  prague: "Prag",
  warsaw: "Varşova",
  copenhagen: "Kopenhag",
  istanbul: "İstanbul",
  antalya: "Antalya",
  bodrum: "Bodrum",
  izmir: "İzmir",
  ankara: "Ankara",
  priceCologneDusseldorf: "99 €'dan başlayan fiyatlarla",
  priceFrankfurtHeidelberg: "79 €'dan başlayan fiyatlarla",
  priceMunichAugsburg: "149 €'dan başlayan fiyatlarla",
  priceHamburgLuebeck: "149 €'dan başlayan fiyatlarla",
  allQuestions: "Tüm Sorular",
  viewAnswers: "Cevapları Görüntüle",
  frequentlyAskedQuestions: "Sıkça Sorulan Sorular",
  questionsAbout: "Hakkında sorular",
  airportTransfer: "Havalimanı Transferi",
  travelKnowledge: "Seyahat Bilgisi",
  guide: "Rehber",
  our: "",
  tipsInsightsNewsDescription: "Havalimanı transferleri, seyahat ve hareketlilik hakkında ipuçları, bilgiler ve haberler.",
  viewAllGuideArticles: "Tüm Rehber Makalelerini Görüntüle",
  haveAQuestion: "Bir sorunuz mu var?",
  travelTips: "Seyahat İpuçları",
  business: "İş",
  family: "Aile",
  stressFreeAirportTransferTitle: "Stressiz Bir Havalimanı Transferi İçin En İyi 7 İpucu",
  stressFreeAirportTransferDescription: "Havalimanına yolculuğunuzu mümkün olduğunca rahat planlayın – doğru zaman payından doğru araç sınıfına kadar.",
  businessTravelTitle: "İş Seyahati: Önemli Toplantınıza Rahat Bir Şekilde Nasıl Ulaşırsınız",
  businessTravelDescription: "Uçuş ile randevu arasında genellikle çok az zaman kalır. Doğru planlamayla zamanında ve dinlenmiş olarak nasıl varacağınızı gösteriyoruz.",
  familyVacationTitle: "Aile Tatili: Çocuklarla Güvenli Bir Şekilde Havalimanına",
  familyVacationDescription: "Çocuk koltukları, bagaj ve yorgun çocuklar – tüm aile için havalimanına yolculuğu rahat tutmak için pratik ipuçları veriyoruz.",
  june12_2026: "12 Haziran 2026",
  may28_2026: "28 Mayıs 2026",
  may15_2026: "15 Mayıs 2026",
  readTime4Minutes: "4 dk okuma",
  readTime3Minutes: "3 dk okuma",
  readTime5Minutes: "5 dk okuma",
  roundTripShort: "Gidiş-Dönüş",
  editSearch: "Aramayı Düzenle",
  edit: "Düzenle",
  startNewSearch: "Yeni Arama Başlat",
  cancel: "İptal",
  search: "Ara",
  dateRequired: "Tarih gerekli",
  timeRequired: "Saat gerekli",
  returnDateRequired: "Dönüş tarihi gerekli",
  returnTimeRequired: "Dönüş saati gerekli",
  vehicleCategory: "Araç Kategorisi",
  reset: "Sıfırla",
  categoryTaxi: "Taksi",
  categoryEconomy: "Ekonomi",
  categoryBusiness: "Business",
  categoryMinibus: "Minibüs",
  categoryMinibusWheelchair: "Minibüs Tekerlekli Sandalye",
  categoryGoGreen: "GoGreen",
  categoryFirstClass: "First Class",
  categoryKomfort: "Konfor",
  categoryLuxury: "Lüks",
  filterTitle: "Filtre",
  passengers: "Yolcular",
  vehiclesForAtLeast: "En az ≥ için araçlar",
  people: "Kişi",
  luggage: "Bagaj",
  luggagePieces: "Bagaj Parçası",
  wheelchair: "Tekerlekli Sandalye",
  allVehicles: "Tüm Araçlar",
  wheelchairSeats: "Tekerlekli Sandalye Koltukları",
  noRatingsYet: "Henüz değerlendirme yok",
  orSimilar: "veya benzeri",
  upTo: "kadar",
  handLuggage: "El Bagajı",
  childSeatGroup1Name: "Çocuk Koltuğu Grup 1",
  childSeatGroup1Desc: "(Yaklaşık 1-4 yaş), 9-18 kg",
  childSeatGroup23Name: "Çocuk Koltuğu Grup 2/3",
  childSeatGroup23Desc: "(Yaklaşık 5-12 yaş), 18-38 kg",
  babySeatName: "Bebek Koltuğu",
  babySeatDesc: "12 aya kadar bebekler için. +1 kg – 9 kg",
  luggageHelpName: "Bagaj Yardımı",
  luggageHelpDesc: "Sürücü bagajınızda size yardımcı olur",
  meetGreetName: "Karşılama Hizmeti",
  meetGreetDesc: "Sürücü sizi isim tabelasıyla karşılar ve bagajınıza yardımcı olur.",
  privateRide: "Özel Yolculuk",
  support247: "7/24 Destek",
  freeCancellation: "Yolculuktan 24 saat öncesine kadar ücretsiz iptal",
  provider: "Sağlayıcı",
  bookNow: "Şimdi Rezervasyon Yap",
  showLess: "Daha Az Göster",
  moreOffers: "daha fazla teklif",
  priceFrom: "Fiyat",
  book: "Rezervasyon Yap",
  loadingOffers: "Teklifler yükleniyor …",
  noOfferIdFound: "Teklif ID'si bulunamadı",
  errorLoadingOffers: "Teklifler yüklenirken hata oluştu",
  unknownError: "Bilinmeyen hata",
  offersFound: "teklif bulundu",
  cheapest: "↑ En Ucuz",
  mostExpensive: "↓ En Pahalı",
  noVehiclesFound: "Seçilen filtreler için araç bulunamadı.",
  resetFilters: "Filtreleri Sıfırla",
  taxi_limousine: "Taksi Sedan",
  taxi_kombi: "Taksi Station Wagon",
  taxi_van: "Taksi Van",
  economy_limousine: "Ekonomi Sedan",
  economy_kombi: "Ekonomi Station Wagon",
  economy_minivan: "Ekonomi Minivan",
  economy_van: "Ekonomi Van",
  business_kombi: "Business Station Wagon",
  business_van: "Business Van",
  minibus: "Minibüs",
  business_limousine: "Business Sedan",
  minibus_wheelchair: "Minibüs Tekerlekli Sandalye",
  gogreen: "GoGreen",
  firstclass: "First Class",
  komfort: "Konfor",
  luxury: "Lüks",
  oclock: "",
  vehicleSection: "Araç",
  max: "Maks",
  included: "Dahil",
  freeCancelShort: "Ücretsiz İptal",
  serviceProviderLabel: "Hizmet Sağlayıcı",
  routeSection: "Güzergah",
  priceOverview: "Fiyat Özeti",
  ride: "Yolculuk",
  total: "Toplam",
  loadingData: "Yükleniyor …",
  noSessionIdFound: "Oturum ID'si bulunamadı",
  dataLoadError: "Veriler yüklenemedi.",
  less: "daha az",
  more: "daha fazla",
  free: "Ücretsiz",
  next: "İleri",
  saving: "Kaydediliyor …",
  errorSavingExtras: "Ek hizmetler kaydedilirken hata oluştu.",
  extraServicesTitle: "Ek Hizmetler",
  transferDetails: "Transfer Detayları",
  closeDetails: "Detayları Kapat",
  showDetails: "Detayları Göster",
  closeShort: "↓ Kapat",
  detailsShort: "↑ Detaylar",
  totalPrice: "Toplam Fiyat",
  childSeatGroup1: "Çocuk Koltuğu Grup 1",
  childSeatGroup1Description: "(Yaklaşık 1-4 yaş), 9-18 kg",
  childSeatGroup2_3: "Çocuk Koltuğu Grup 2/3",
  childSeatGroup2_3Description: "(Yaklaşık 5-12 yaş), 18-38 kg",
  infantCarrier: "Bebek Koltuğu",
  infantCarrierDescription: "12 aya kadar bebekler için. +1 kg – 9 kg",
  waterSnack: "Su ve atıştırmalık",
  waterSnackDescription: "Araçta sizi bir şişe su ve küçük bir atıştırmalık bekler.",
  petTransport: "Evcil hayvan taşıma",
  petTransportDescription: "Evcil hayvanınız da yolculuk eder. Lütfen taşıma kutusu veya tasma bulundurun.",
  welcomeFlowers: "Çiçek / karşılama paketi",
  welcomeFlowersDescription: "Misafirleriniz için araçta çiçek buketi veya karşılama paketi – otel ve düğün için ideal.",
  powerBank: "Powerbank / şarj kablosu",
  powerBankDescription: "Telefonunuz dolu varsın diye araçta şarj kablosu ve powerbank.",
  wifiHotspot: "Wi-Fi erişim noktası",
  wifiHotspotDescription: "Yolculuk boyunca araçtaki Wi-Fi ile çevrimiçi kalın.",
  priorityPickup: "Öncelikli karşılama",
  priorityPickupDescription: "Şoför doğrudan kapıda bekler ve bagaj arabasıyla yardımcı olur – araca en hızlı yol.",
  luggageAssistance: "Bagaj Yardımı",
  luggageAssistanceDescription: "Sürücü bagajınızda size yardımcı olur",
  meetAndGreet: "Karşılama Hizmeti",
  meetAndGreetDescription: "Sürücü sizi isim tabelasıyla karşılar ve bagajınıza yardımcı olur.",
  errorSavingData: "Veri kaydedilirken hata oluştu.",
  fillRequiredFields: "Lütfen tüm zorunlu alanları doldurun",
  fillAllRequiredFields: "Lütfen tüm zorunlu alanları doldurun",
  requiredField: "Zorunlu alan",
  invalidEmail: "Geçersiz e-posta adresi",
  pleaseSelect: "lütfen seçin",
  title: "Başlık",
  salutation: "Hitap",
  lastName: "Soyad",
  firstName: "Ad",
  mobileNumber: "Cep Telefonu No.",
  emailAddress: "E-posta Adresi",
  zipCode: "Posta Kodu",
  city: "Şehir",
  address: "Adres",
  houseNumber: "Kapı No.",
  flightNumber: "Uçuş Numarası",
  infoForDriver: "Sürücü İçin Bilgi",
  personalDataTitle: "Kişisel Bilgiler",
  personalDataDesc: "Kişinize ait bilgiler",
  contactTitle: "İletişim",
  contactDesc: "Hizmet sağlayıcının sorularınız için sizinle iletişime geçebilmesi için iletişim bilgilerinizi buraya girin.",
  addressTitle: "Adres",
  addressDesc: "Faturada doğru şekilde belirtilebilmesi için lütfen tam adresinizi girin.",
  outboundFlightTitle: "Gidiş Uçuşu Bilgileri",
  returnFlightTitle: "Dönüş Uçuşu Bilgileri",
  flightDataDesc: "Transferinizi en iyi şekilde planlayabilmemiz için lütfen tam uçuş bilgilerinizi girin.",
  mr: "Bay",
  mrs: "Bayan",
  diverse: "Diğer",
  reviewAndPayTitle: "Bilgileri Kontrol Et & Ödeme",
  choosePaymentMethod: "Ödeme Yöntemi Seçin",
  comingSoon: "Yakında",
  cashLabel: "Nakit Ödeme",
  cashDesc: "Doğrudan sürücüye ödeme – rezervasyon hemen onaylanır",
  cardOnTripLabel: "Sürücüye Kart ile Ödeme",
  cardOnTripDesc: "Transfer günü yerinde kartla ödeme",
  stripeLabel: "Kredi / Banka Kartı",
  stripeDesc: "Visa, Mastercard, Amex, Apple Pay, Google Pay – anında onay",
  customOfferLabel: "Teklif Yap",
  customOfferDesc: "Kendi fiyatınızı önerin – sağlayıcı inceler ve onaylar",
  yourOfferLabel: "Fiyat Teklifiniz",
  offerHint: "⏳ Sağlayıcı tarafından onaylanmalıdır – onaylandıktan sonra e-posta ile bir ödeme bağlantısı alacaksınız.",
  offerInfoBanner: "Fiyat teklifiniz sağlayıcıya iletilecektir. Sağlayıcının önce teklifinizi onaylaması gerekir. Onaylandıktan sonra e-posta ile size özel bir ödeme bağlantısı alacaksınız.",
  invoiceLabel: "Fatura ile",
  invoiceDesc: "Fatura alındıktan sonra ödeme",
  installmentLabel: "Taksitli Ödeme",
  installmentDesc: "Uygun taksitlerle ödeyin",
  couponTitle: "Kupon Kodu",
  couponPlaceholder: "Kod girin …",
  redeem: "Kullan",
  couponInvalid: "Bu kupon geçersiz.",
  couponSuccess: "✓ Kupon kullanıldı!",
  bookingOverviewTitle: "Rezervasyon Özeti",
  reviewYourDataDesc: "Bilgilerinizi kontrol edin",
  contactShortDesc: "İletişim bilgileriniz",
  emailShort: "E-posta",
  billingAddressDesc: "Fatura adresi",
  zipShort: "Posta Kodu",
  outboundFlightDesc: "Gidiş uçuşu bilgileri",
  returnFlightDesc: "Dönüş uçuşu bilgileri",
  checkoutLabel: "Ödeme",
  sumLabel: "Ara Toplam",
  regularPrice: "Normal Fiyat",
  vatNote: "* KDV dahil",
  shareLink: "Bağlantıyı Paylaş",
  scanQrCode: "QR Kodu Tarayın",
  qrCodeAlt: "Bu sayfanın QR kodu",
  copyLink: "Bağlantıyı Kopyala",
  linkCopied: "✓ Bağlantı kopyalandı!",
  agbTextBefore: "Şunu okudum:",
  agbLinkLabel: "Genel Şartlar ve Koşullar",
  agbTextAfter: "ve kabul ediyorum. *",
  newsletterOptinLabel: "Evet, bültenle almak ve teklifleri kaçırmak istemiyorum.",
  agbRequiredHint: "* Devam etmek için lütfen Şartlar ve Koşulları kabul edin.",
  sendingOffer: "Teklif gönderiliyor …",
  redirecting: "Yönlendiriliyor …",
  submitOffer: "Teklifi Gönder",
  payNow: "Şimdi Öde",
  bookingSubmitError: "Rezervasyon gönderilirken hata oluştu.",
  stripeSecureNote: "Güvenli ödeme – Stripe ile desteklenmektedir",
  cashNote: "Doğrudan sürücüye nakit ödeme",
  offerPendingNote: "Sağlayıcı onaylıyor & ödeme bağlantısı gönderiyor",
  completePaymentLabel: "Ödemeyi Tamamla",
  footerCompanyDescription: "Size her yerde ve her zaman güvenilir, yüksek kaliteli havalimanı transferleri sunmak için hizmetimizi geliştirdik – hiçbir sorun olmadan.",
  footerLinksTitle: "Bağlantılar",
  aboutUs: "Hakkımızda",
  bookTransfer: "Transfer Rezervasyonu",
  footerServiceTitle: "Hizmet",
  vehicleFleet: "Araç Filosu",
  faq: "SSS",
  footerLegalTitle: "Yasal",
  imprint: "Yasal Bildirim",
  privacyPolicy: "Gizlilik Politikası",
  termsAndConditions: "Şartlar ve Koşullar",
  newsletterTitle: "Bülten",
  newsletterDescription: "Güncel haberler ve güncellemeler doğrudan gelen kutunuzda.",
  emailPlaceholder: "E-posta adresiniz",
  sending: "Gönderiliyor…",
  subscribe: "Abone Ol",
  newsletterEmailRequired: "Lütfen bir e-posta adresi girin.",
  newsletterEmailInvalid: "Lütfen geçerli bir e-posta adresi girin.",
  newsletterSuccess: "Teşekkürler! Başarıyla abone oldunuz.",
  newsletterError: "Abonelik başarısız oldu. Lütfen tekrar deneyin.",
  allRightsReserved: "Tüm hakları saklıdır.",
  affiliateProgram: "Ortaklık Programı",
  affiliateHeroTitle: "Bir parçası olun",
  affiliateHeroAccent: "GoTransfer24.",
  affiliateHeroSub: "Bizi sosyal medya, web siteniz veya şirketiniz üzerinden önerin ve başarıyla yönlendirdiğiniz her yolculuktan komisyon kazanın.",
  becomeAffiliateCta: "Ortak Ol",
  whyPartnerWithUs: "Neden Bizimle Ortaklık Yapmalısınız?",
  affiliateBenefitsTitleLine1: "Ortak olarak",
  affiliateBenefitsTitleLine2: "elde ettikleriniz.",
  affiliateBenefit1: "Yönlendirilen her rezervasyon için özel komisyon",
  affiliateBenefit2: "Kolay takip için kendi bağlantınız",
  affiliateBenefit3: "Aylık ödeme, tam şeffaflık",
  affiliateBenefit4: "Minimum ciro yok, gizli maliyet yok",
  affiliateCommissionTitle: "Komisyon nasıl hesaplanır?",
  affiliateCommissionExplanationText: "Komisyon, erişim, hedef kitle ve beklenen yönlendirme hacmine göre bireysel olarak hesaplanır. Ortak profilinize bağlı olarak, başarıyla yönlendirilen her rezervasyon için genellikle %5 ile %15 arasında değişir. Başvurunuzdan sonra, size özel oranınızla kişisel bir teklif alacaksınız.",
  affiliateCommissionDisclaimer: "Komisyon bireysel olarak hesaplanır ve başvurunuzun incelenmesinden sonra bildirilir.",
  affiliateStepsTitle: "3 Adımda Ortak Olun",
  affiliateStep1Title: "Başvurun",
  affiliateStep1Desc: "Formu doldurun ve erişiminizi belirtin.",
  affiliateStep2Title: "İnceleme & Teklif",
  affiliateStep2Desc: "Profilinizi inceliyoruz ve size özel oranınızı gönderiyoruz.",
  affiliateStep3Title: "Öner & Kazan",
  affiliateStep3Desc: "Bağlantınızı paylaşın ve her rezervasyondan komisyon kazanın.",
  affiliateFinalCtaTitle: "Bizimle büyümeye hazır mısınız?",
  affiliateMetaTitle: "Ortaklık Programı",
  affiliateMetaDescription: "GoTransfer24 ortağı olun ve yönlendirdiğiniz her havalimanı transferi rezervasyonundan bireysel olarak hesaplanan komisyon kazanın.",
  becomeAffiliateTitle: "Ortak Ol",
  becomeAffiliateIntro: "Formu doldurun – size özel bir teklifle geri döneceğiz.",
  firstNameRequiredError: "Lütfen adınızı girin",
  lastNameRequiredError: "Lütfen soyadınızı girin",
  emailRequiredError: "Lütfen e-posta adresinizi girin",
  emailInvalidError: "Lütfen geçerli bir e-posta adresi girin",
  atLeastOneOfTheFollowing: "Aşağıdaki alanlardan en az birini doldurun:",
  atLeastOneSocialRequiredError: "Lütfen en az bir sosyal medya hesabı veya şirket belirtin",
  companyOptional: "Şirket (opsiyonel)",
  companyNamePlaceholder: "Şirket adı",
  submitApplication: "Başvuruyu Gönder",
  affiliateApplicationReceivedTitle: "Başvuru Alındı!",
  affiliateApplicationReceivedText: "İlginiz için teşekkür ederiz. Bilgilerinizi inceleyip size özel komisyon teklifimizle geri döneceğiz.",
  close: "Kapat",
  successTitleOffer: "Teklif Alındı!",
  successTitleConfirmed: "Rezervasyon Onaylandı!",
  emailFallback: "E-posta adresiniz",
  thankYouLabel: "Teşekkürler",
  offerSubtitlePart1: "! Fiyat teklifiniz",
  offerSubtitlePart2: "sağlayıcıya iletildi. İnceleme sonrasında size özel bir ödeme bağlantısı alacaksınız:",
  cashSubtitlePart1: "! Rezervasyonunuz onaylandı. Lütfen tutarı doğrudan sürücüye ödeyin. Bir onay şu adrese gönderilecek:",
  defaultSubtitlePart1: "! Ödemeniz başarıyla işlendi. Bir rezervasyon onayı şu adrese gönderilecek:",
  bookingNumberLabel: "Rezervasyon Numarası",
  paymentTypeLabel: "Ödeme Türü",
  creditCardLabel: "Kredi Kartı",
  offerPaymentTypeLabel: "Teklif",
  statusLabel: "Durum",
  statusPendingProviderCheck: "Beklemede – Sağlayıcı inceliyor",
  statusConfirmed: "Onaylandı",
  redirectingToOverviewPart1: "Rezervasyon özetine",
  secondsLabel: "saniye",
  redirectingToOverviewPart3: "içinde yönlendirileceksiniz …",
  redirectFailedText: "Otomatik yönlendirme başarısız oldu.",
  goToBookingOverview: "Rezervasyon Özetine Git →",
  backToHomeLabel: "Ana Sayfaya Dön",
  cookieSettings: "Çerez Ayarları",
  logout: "Çıkış Yap",
  language: "Dil",
  ourtransfers: "Yolculuklarım",
  profiledescription: "Size atanan tüm transfer rezervasyonları",
  rows: "Kayıt",
  filtered: "filtrelendi",
  searchPlaceholder: "Ara",
  pagingOf: "/",
  searchLabel: "Ara",
  resetFilter: "sıfırla",
  selectedCount: "seçildi",
  clearSelection: "temizle",
  menuOpen: "Menüyü aç",
  menuClose: "Menüyü kapat",
  flightScheduled: "Planlandı",
  flightActive: "Uçuşta",
  flightLanded: "İndi",
  flightCancelled: "İptal Edildi",
  flightDiverted: "Yönlendirildi",
  flightIncident: "Olay",
  flightRedirected: "Yönlendirildi",
  flightPrefix: "Uçuş",
  flightLoading: "Uçuş verileri yükleniyor …",
  flightNotFound: "Şunun için uçuş verisi bulunamadı:",
  flightCheckNote: "Lütfen nottaki uçuş numarasını kontrol edin.",
  flightDeparture: "Kalkış",
  flightArrival: "Varış",
  flightPlanned: "Planlandı",
  flightDelay: "Gecikme",
  flightDelayDep: "dk kalkış",
  flightDelayArr: "dk varış",
  flightBaggage: "Bagaj Bandı",
  flightBaggageBand: "Bant",
  flightAirline: "Havayolu",
  chatWithCustomer: "Müşteriyle Sohbet",
  chatBooking: "Rezervasyon",
  chatLoading: "Mesajlar yükleniyor …",
  chatEmpty: "Henüz mesaj yok. Müşteriye bir mesaj yazın.",
  chatInputPlaceholder: "Mesaj yazın …",
  chatDisabled: "Sohbet geçmiş/gelecek yolculuklar için devre dışı",
  chatOnlyToday: "Sohbet sadece yolculuk günü kullanılabilir",
  chatClose: "Sohbeti Kapat",
  chatOpenLabel: "Sohbeti Aç",
  chatButtonLabel: "Sohbet",
  chatLoadError: "Mesajlar yüklenirken hata oluştu",
  chatSendFail: "Mesaj gönderilemedi",
  chatSendError: "Mesaj gönderilirken hata oluştu",
  salutationMr: "Bay",
  salutationMrs: "Bayan",
  tripReturn: "Gidiş-Dönüş",
  tripOneway: "Tek Yön",
  noTripsAvailable: "Yolculuk bulunmuyor.",
  noTripsSearch: "Mevcut arama için sonuç bulunamadı",
  noTrips: "Yolculuk bulunmuyor",
  pickupTag: "Alış",
  destinationTag: "Varış",
  paymentLabel: "Ödeme",
  passengersLabel: "Yolcular",
  customerLabel: "Müşteri",
  phoneLabel: "Telefon Numarası",
  extrasLabel: "Ekstralar",
  noteLabel: "Not",
  flightInfoLabel: "Uçuş Bilgisi",
  yourSharePrefix: "Payınız (gidiş)",
  cancelBtn: "İptal Et",
  counterOfferBtn: "Karşı Teklif",
  waitingCustomerResponse: "Müşteri yanıtı bekleniyor",
  newBadge: "Yeni",
  enrouteBtn: "Yolda",
  onboardBtn: "Alındı",
  noshowBtn: "Gelmedi",
  completeBtn: "Tamamla",
  cancelledBadge: "İptal Edildi",
  completedBadge: "Tamamlandı",
  noshowDoneBadge: "Gelmedi",
  complainedBadge: "Şikayet Edildi",
  cancelTripTitle: "Yolculuk İptal Edilsin mi?",
  cancelBookingPrefix: "Rezervasyon",
  cancelIrreversible: "Bu işlem geri alınamaz.",
  cancelNotifyText: "Yolculuk iptal edilecek ve müşteri bilgilendirilecek.",
  fromLabel: "Nereden",
  toLabel: "Nereye",
  dateLabel: "Tarih",
  abortBtn: "İptal",
  confirmCancelBtn: "Evet, şimdi iptal et",
  tripCancelledToast: "iptal edildi",
  cancelErrorToast: "İptal edilirken hata oluştu",
  statusEnrouteLabel: "Yola Çık",
  statusEnrouteDesc: "Şimdi müşteriye doğru yola çıkıyorsunuz.",
  statusOnboardLabel: "Yolcu Alındı",
  statusOnboardDesc: "Yolcuyu aldığınızı onaylıyorsunuz.",
  statusCompletedLabel: "Yolculuğu Tamamla",
  statusCompletedDesc: "Bu yolculuğu tamamlandı olarak işaretliyorsunuz.",
  confirmBtn: "Onayla",
  statusUpdateError: "Güncellenirken hata oluştu",
  statusEnrouteToast: "Yola çıkıldı",
  statusOnboardToast: "Yolcu alındı",
  statusCompletedToast: "Yolculuk tamamlandı",
  counterOfferTitle: "Karşı Teklif Yap",
  originalPriceLabel: "Orijinal Fiyat",
  customerOfferLabel: "Müşteri Teklifi",
  yourCounterOfferLabel: "Karşı Teklifiniz",
  counterOfferInvalid: "Lütfen geçerli bir tutar girin.",
  counterOfferSaveError: "Kaydedilirken hata oluştu. Lütfen tekrar deneyin.",
  counterOfferNotifyInfo: "Kaydedildikten sonra müşteri bilgilendirilecek.",
  counterOfferSaving: "Kaydediliyor …",
  counterOfferSendBtn: "Karşı Teklif Gönder",
  counterOfferSavedToast: "Şunun için karşı teklif:",
  counterOfferSavedToastSuffix: "kaydedildi",
  vehicleDialogTitle: "Araç Seçin",
  vehicleLoading: "Araçlar yükleniyor …",
  vehicleLoadError: "Araçlar yüklenemedi.",
  vehicleLoadErrorGeneric: "Araçlar yüklenirken hata oluştu.",
  vehicleNoneAvailable: "Uygun araç yok.",
  vehicleStarting: "Başlatılıyor …",
  vehicleStartBtn: "Yola Çık",
  vehiclePleaseChoose: "Lütfen bir araç seçin",
  vehicleSaveError: "Kaydedilirken hata oluştu.",
  vehicleStartError: "Yola çıkarken hata oluştu.",
  vehicleStartedToast: "Yola çıkıldı",
  vehicleFallbackName: "Araç",
  noshowDialogTitle: "Gelmedi Bildir",
  noshowInstructions: "Lütfen aracınızın açıkça görüldüğü alış noktasının bir fotoğrafını çekin. Konum otomatik olarak kaydedilecektir.",
  noshowMaxSizeSuffix: "Maks.",
  currentLocationLabel: "Mevcut Konum",
  locationLoading: "Konum belirleniyor …",
  locationReload: "Yeniden Yükle",
  locationRetry: "Tekrar Dene",
  locationUnavailable: "Konum mevcut değil",
  geoNotSupported: "Konum belirleme bu cihaz tarafından desteklenmiyor.",
  geoDenied: "Konum belirlenemedi. Lütfen erişime izin verin.",
  photoOfPickupLabel: "Alış Noktasının Fotoğrafı",
  photoTakeLabel: "Fotoğraf Çek",
  photoHint: "Kamerayı aç · Araç görünür olmalı",
  photoChange: "Değiştir",
  noshowNoteLabel: "Not",
  noshowNoteOptional: "(opsiyonel)",
  noshowNotePlaceholder: "örn. zil çalışmıyor, aramaya cevap yok …",
  noshowMissingPhoto: "Lütfen alış noktasının bir fotoğrafını çekin.",
  noshowLocationPending: "Konum hala belirleniyor. Lütfen bekleyin.",
  noshowPhotoTooLargePrefix: "Fotoğraf çok büyük",
  noshowPhotoTooLargeMax: "Maksimum",
  noshowPhotoTooLargeHint: "Lütfen daha küçük bir fotoğraf çekin veya kamera kalitesini düşürün.",
  noshowPhotoTooLargeHintShort: "Lütfen daha küçük bir fotoğraf çekin.",
  noshowGenericSaveError: "Kaydedilirken hata oluştu. Lütfen tekrar deneyin.",
  noshowSubmitError: "Gönderilirken hata oluştu. Lütfen tekrar deneyin.",
  noshowSubmitting: "Gönderiliyor …",
  noshowConfirmBtn: "Gelmedi Onayla",
  noshowReportedToast: "Şunun için gelmedi bildirildi:",
  pickupLabel: "Alış Noktası",
  current: "Güncel",
  trips: "Yolculuklar",
  myData: "Bilgilerim",
  documents: "Belgeler",
  other: "Diğer",
  vehicle_class: "Araçlarım",
  company: "Şirketim",
  cities: "Şehirler",
  wallet: "Cüzdan",
  receipts: "Makbuzlar",
  terms: "Şartlar ve Koşullar",
  privacy: "Gizlilik Politikası",
  new: "Yeni",
  overview: "Genel Bakış",
  income: "Gelir",
  expenses: "Gider",
  welcomeBack: "Tekrar Hoş Geldiniz",
  dashboardErrorTitle: "Bir şeyler ters gitti",
  dashboardErrorText: "Veriler yüklenemedi.",
  noWidgetsTitle: "Widget Yapılandırılmamış",
  noWidgetsText: "Şu anda kullanılabilir özet kartı yok.",
  completed: "Tamamlandı",
  upcoming: "Yaklaşan",
  cancelled: "İptal Edildi",
  noShow: "Gelmedi",
  complained: "Şikayet Edildi",
  tomorrow: "Yarın",
  thisWeek: "Bu Hafta",
  count: "Sayı",
  ofWhichNoShow: "Bunlardan gelmeyenler",
  ofWhichComplained: "Bunlardan şikayet edilenler",
  transfer_total: "Toplam",
  transfer_done: "Tamamlandı",
  transfer_open: "Yaklaşan",
  transfer_week: "Bu Hafta",
  transfer_storno_reklamiert: "Bunlardan şikayet edilenler",

  newTrips: "Yeni Yolculuklar",
  notransferdatafound: "Yolculuk bulunmuyor.",
  noResultsForFilters: "Mevcut filtreler için sonuç bulunamadı",
  returnTripOn: "Dönüş yolculuğu tarihi:",

  generateInvoice: "Fatura Oluştur",
  details: "Detaylar",
  accept: "Kabul Et",
  changeDriver: "Sürücü Değiştir",
  assignDriver: "Sürücü Ata",
  cancelList: "İptal Et",

  counterOffer: "Karşı Teklif",
  acceptOffer: "Teklifi Kabul Et",
  waitingForCustomerResponse: "Müşteri yanıtı bekleniyor",
  waitingForCustomerPayment: "Müşteri ödemesi bekleniyor",
  accepted: "Kabul Edildi",

  pleaseAssignDriver: "Lütfen bir sürücü atayın",
  driverOnTheWay: "Sürücü yolda",

  customerOnBoard: "Müşteri araçta",

  acceptOfferQuestion: "Teklif kabul edilsin mi?",
  bookingPrefix: "Rezervasyon",

  confirmCustomerOffer: "Müşteri Teklifini Onayla",
  customerOfferPaymentInfo: "Müşteri e-posta ile bilgilendirilecek ve ödemeye yönlendirilecek. Ödeme sonrasında rezervasyon otomatik olarak onaylanacaktır.",

  offerPrice: "Teklif Fiyatı",

  yesAcceptOffer: "Evet, teklifi kabul et",

  selectDriver: "Sürücü Seç",
  loadingDrivers: "Sürücüler yükleniyor …",
  noDriversAvailable: "Uygun sürücü yok.",

  confirmTrip: "Yolculuğu Onayla",
  pleaseSelectDriver: "Lütfen bir sürücü seçin",

  cancelTripQuestion: "Yolculuk iptal edilsin mi?",
  cancelNotifyCustomer: "Yolculuk iptal edilecek ve müşteri bilgilendirilecek.",

  from: "Nereden",
  to: "Nereye",

  confirmCancel: "Evet, şimdi iptal et",

  create: "Oluştur",

  makeCounterOffer: "Karşı Teklif Yap",
  originalPrice: "Orijinal Fiyat",
  customerOffer: "Müşteri Teklifi",
  yourCounterOffer: "Karşı Teklifiniz",
  counterOfferNotify: "Kaydedildikten sonra müşteri bilgilendirilecek.",
  sendCounterOffer: "Karşı Teklif Gönder",
  // StepDialog (Yeni Kayıt)
  newRecordTitle: "Yeni Kayıt Oluştur",
  stepLabel: "Adım",
  ofLabel: "/",
  enterValuePlaceholder: "girin...",
  yes: "Evet",
  no: "Hayır",

  // MatchDialog
  selectMatch: "Seçim Yapın",

  // ConfirmDialog
  affectedRecords: "Etkilenen Kayıtlar:",

  // FilterDialog
  applyFilterTitle: "Filtre Uygula",
  applyFilterSubtitle: "Kayıtları kriterlere göre filtrele",
  active: "Aktif",
  inactive: "Pasif",
  noFilterableFields: "Filtrelenebilir alan yok",
  applyFilterButton: "✓ Filtreyi Uygula",

  // AdminEditDialog
  editRecordTitle: "Kaydı Düzenle",
  bookingLabel: "Rezervasyon",
  noEditableFields: "Düzenlenebilir alan yapılandırılmamış",
  savingEllipsis: "Kaydediliyor …",
  saveButton: "✓ Kaydet",
  adminEditTooltip: "Kaydı düzenle (Yönetici)",

  // Footer / Paging
  filteredLabel: "(filtrelendi)",
  recordsLabel: "Kayıt",
  filterLabel: "Filtre:",
  selectedLabel: "seçildi",
  clearLabel: "temizle",

  // Trip-Type Fallbacks
  tripTypeReturn: "Gidiş-Dönüş",
  tripTypeOneway: "Tek Yön",

  // Formatting
  driverFallbackPrefix: "Sürücü #",

  // Toasts
  toastOfferAccepted: "#{id} için teklif kabul edildi – müşteri bilgilendirilecek",
  toastInvoiceCreated: "#{id} için fatura oluşturuldu",
  toastDriverChanged: "Sürücü değiştirildi",
  toastDriverConfirmed: "onaylandı",
  toastTripUpdated: "#{id} yolculuğu {label} olarak güncellendi",
  toastTripCancelled: "#{id} yolculuğu iptal edildi",
  toastCounterOfferSaved: "#{id} için karşı teklif kaydedildi",
  toastRecordUpdated: "#{id} kaydı güncellendi",

  // Error Messages
  errorAcceptOffer: "Teklif kabul edilirken hata oluştu",
  errorCreateInvoice: "Fatura oluşturulurken hata oluştu",
  errorSaveTrip: "Yolculuk kaydedilirken hata oluştu.",
  errorChangeDriver: "Sürücü değiştirilirken hata oluştu.",
  errorConfirmTrip: "Yolculuk onaylanırken hata oluştu.",
  errorCancelTrip: "İptal edilirken hata oluştu",
  errorInvalidAmount: "Lütfen geçerli bir tutar girin.",
  errorSaveRetry: "Kaydedilirken hata oluştu. Lütfen tekrar deneyin.",
  errorLoadDriversFailed: "Sürücüler yüklenemedi.",
  errorLoadDrivers: "Sürücüler yüklenirken hata oluştu.",
  errorSaveDefault: "Kaydedilirken hata oluştu",
  discount: "İndirim",
  couponAvailableNote: "İndirim kuponunuzu şimdi alın!",
  copied: "Kopyalandı!",
  clickToCopy: "Kopyalamak için tıklayın",
  appDownloadBannerText: "GoTransfer24 Uygulaması",
  appDownloadBannerCta: "İndir",
  planned: "Planlandı",
  aktive_stat: "Aktif",
  done: "Tamamlandı",
  en_route: "Sürücü yolda",
  onboard: "Müşteri araçta",
  card: "Kart Ödemesi",
  cash: "Nakit Ödeme",
  cardOnTrip: "Sürücüye Kart ile Ödeme",
  cardontrip: "Sürücüye Kart ile Ödeme",
  thisweek: "Bu Hafta",
  unpaid: "Ödeme Bekliyor",
  paid: "Ödendi",
  paypalLabel: "PayPal",
  paypalDesc: "PayPal hesabınızla güvenli bir şekilde ödeyin",
  paypalSecureNote: "Güvenli bir şekilde PayPal'a yönlendirileceksiniz",
  redirectingPaypal: "PayPal'a yönlendiriliyor …",
  paypalCancelledNote: "PayPal ödemesi iptal edildi.",
  paypalFailedNote: "PayPal ödemesi tamamlanamadı.",
  paypal: "paypal",
  actual: "Güncel",
  transfers: "Yolculuklar",
  mydata: "Bilgilerim",
  others: "Diğer",
  vehicleclass: "Araçlarım",
  impressum: "Yasal Bildirim",
  agb: "Şartlar ve Koşullar",
  datenschutz: "Gizlilik Politikası",
  booking: "Rezervasyon",
  transferTripLabel: "Transfer Yolculuğu",
  outboundReturnTrip: "Gidiş-Dönüş",
  onewayTrip: "Tek Yön",
  departureLabel: "Kalkış",
  distanceLabel: "Mesafe",
  returnTripSection: "Dönüş Yolculuğu",
  customerSection: "Müşteri",
  baggageLabel: "Bagaj",
  emergencyContactLabel: "Acil Durum İletişimi",
  paymentSection: "Ödeme",
  basePriceLabel: "Taban Fiyat",
  offerPriceLabel: "Teklif Fiyatı",
  counterOfferLabel: "Karşı Teklif",
  categoryLabel: "Kategori",
  paymentMethodLabel: "Ödeme Yöntemi",
  pricePerKmLabel: "Fiyat/km",
  receiptLabel: "Makbuz",
  createdLabel: "Oluşturuldu",
  notCreatedYetLabel: "Henüz oluşturulmadı",
  noCounterOfferYet: "Henüz karşı teklif verilmedi",
  priceAccepted: "Fiyat kabul edildi",
  noShowReportSection: "Gelmedi Bildirimi",
  reportedAtLabel: "Bildirilme Zamanı",
  accuracyLabel: "Doğruluk",
  locationLabel: "Konum",
  openInGoogleMaps: "Google Maps'te Aç",
  driverNoteLabel: "Sürücü Notu",
  driverNoticeLabel: "Sürücü Bildirimi",
  driverPhotoLabel: "Sürücüden Fotoğraf",
  noShowPhotoAlt: "Gelmedi kanıt fotoğrafı",
  extrasSection: "Ekstra / Ek Hizmetler",
  totalExtrasLabel: "Toplam Ekstra",
  notesSection: "Notlar",
  customerNoteLabel: "Müşteri Notu",
  shortNoteLabel: "Kısa Not",
  internalNoteLabel: "Dahili Not",
  ratingSection: "Değerlendirme",
  bookingDetailsSection: "Rezervasyon Detayları",
  createdAtLabel: "Oluşturulma Tarihi",
  updatedAtLabel: "Güncellenme",
  bookingSourceLabel: "Rezervasyon Kaynağı",
  tripTypeLabel: "Yolculuk Türü",
  externalIdLabel: "Harici ID",
  canceledAtLabel: "İptal Edilme Tarihi",
  cancelReasonLabel: "İptal Nedeni:",
  paymentPendingLabel: "Ödeme Bekliyor",
  paidLabel: "Ödendi",
  paymentFailedLabel: "Başarısız",
  sourceWebsite: "Web Sitesi",
  sourceManual: "Manuel",
  sourceApi: "API",
  // Türkçe (tr.js)
  pleaseSelectImageFile: "Lütfen bir resim dosyası seçin.",
  fileTooLargeError: "Dosya çok büyük (maks. 10 MB).",
  driverCreatedToast: "Sürücü oluşturuldu",
  driverCreateErrorFallback: "Sürücü oluşturulurken hata oluştu",
  deleteDriverTitle: "Sürücüyü Sil",
  deleteDriverConfirmPrefix: "Gerçekten silmek istiyor musunuz:",
  deleteDriverConfirmSuffix: "? Bu işlem geri alınamaz.",
  driverDeletedToast: "Sürücü silindi",
  deleteErrorToast: "Silinirken hata oluştu",
  wasDeactivated: "devre dışı bırakıldı",
  wasActivated: "etkinleştirildi",
  statusUpdateErrorToast: "Durum güncellenirken hata oluştu",
  licenseExpired: "Süresi Doldu",
  licenseExpiresIn: "Süre bitimine",
  daysAbbrev: "gün",
  licenseValidUntil: "Şu tarihe kadar geçerli:",
  activeLabel: "Aktif",
  inactiveLabel: "Pasif",
  detailsButton: "Detaylar",
  deactivateButton: "Devre Dışı Bırak",
  activateButton: "Etkinleştir",
  deleteButton: "Sil",
  createDriverTitle: "Yeni Sürücü Ekle",
  yesLabel: "Evet",
  noLabel: "Hayır",
  enterPlaceholderSuffix: "girin…",
  enterPlaceholderSuffixNoDots: "girin...",
  profilePhotoLabel: "Profil Fotoğrafı",
  optionalLabel: "opsiyonel",
  previewAlt: "Önizleme",
  changePhotoLabel: "Fotoğrafı Değiştir",
  uploadPhotoLabel: "Fotoğraf Yükle",
  removePhotoLabel: "Fotoğrafı Kaldır",
  photoOptionalHint: "Zorunlu değil – fotoğraf daha sonra profilde de eklenebilir.",
  cancelButton: "İptal",
  creatingLabel: "Oluşturuluyor…",
  createButton: "Oluştur",
  enabledLabel: "Etkin",
  disabledLabel: "Devre Dışı",
  filterDriversDesc: "Sürücüleri kriterlere göre filtrele",
  resetButton: "Sıfırla",
  filterButton: "Filtre",
  newDriverButton: "Yeni Sürücü",
  ofLabelLower: "/",
  driversLabel: "Sürücüler",
  searchColonLabel: "Ara:",
  resetLowerButton: "sıfırla",
  filterColonLabel: "Filtre:",
  clearLowerButton: "temizle",
  loadingAriaLabel: "Yükleniyor…",
  // Türkçe (tr.js)
  driverSavedToast: "Sürücü kaydedildi",
  saveErrorToast: "Kaydedilirken hata oluştu",
  imageProcessingError: "Görsel işlenirken hata oluştu.",
  savingLabel: "Kaydediliyor…",
  photoCardTitle: "Fotoğraf",
  photoSizeHint: "JPG/PNG, maks. 10 MB · 300×600 px'e küçültülecek",
  dataCardTitle: "Bilgiler",
  // Türkçe (tr.js)
  licensePlateHint: "Format: 1–3 harf, 1–2 harf, 1–4 rakam – örn. M AB 1234",
  pricesLoadError: "Fiyatlar yüklenemedi.",
  vehiclesLoadError: "Araçlar yüklenemedi.",
  pleaseSelectBrandError: "Lütfen bir marka seçin veya girin",
  pleaseSelectModelError: "Lütfen bir model seçin veya girin",
  pleaseSelectColorError: "Lütfen bir renk seçin veya girin",
  pleaseEnterLicensePlateError: "Lütfen bir plaka girin",
  invalidFormatPrefix: "Geçersiz format –",
  vehicleAddedToast: "Araç eklendi",
  vehicleAddErrorToast: "Araç eklenirken hata oluştu",
  vehicleDeletedToast: "Araç silindi",
  vehicleDeleteErrorToast: "Araç silinirken hata oluştu",
  vehicleActivatedToast: "Araç etkinleştirildi",
  vehicleDeactivatedToast: "Araç devre dışı bırakıldı",
  statusChangeErrorToast: "Durum değiştirilirken hata oluştu",
  pleaseSFillValidPricePrefix: "Lütfen doldurun:",
  pleaseSFillValidPriceSuffix: "geçerli bir fiyatla",
  pricesSavedToast: "Fiyatlar kaydedildi",
  pricesSaveErrorToast: "Fiyatlar kaydedilirken hata oluştu",
  vehicleCategoriesTitle: "Araç Kategorileri",
  vehicleCategoriesDesc: "Kademeli fiyatları ve araçları doğrudan kategoriye göre yönetin.",
  vehiclesInThisClass: "Bu sınıftaki araçlar",
  pricesSectionLabel: "Fiyatlar",
  tiersLabel: "Kademeler",
  pricePerKmShort: "€ / km",
  minPriceLabel: "Minimum Fiyat",
  savePricesButton: "Fiyatları Kaydet",
  vehiclesSectionLabel: "Araçlar",
  loadingVehiclesLabel: "Araçlar yükleniyor…",
  noVehiclesInClassLabel: "Bu sınıfta araç yok",
  brandLabel: "Marka",
  modelLabel: "Model",
  colorLabel: "Renk",
  licensePlateLabel: "Plaka",
  addVehicleTitle: "Araç Ekle",
  selectBrandOption: "Marka seçin…",
  otherOption: "Diğer…",
  enterBrandPlaceholder: "Marka girin",
  selectModelOption: "Model seçin…",
  selectBrandFirstOption: "Önce marka seçin",
  enterModelPlaceholder: "Model girin",
  selectColorOption: "Renk seçin…",
  enterColorPlaceholder: "Renk girin",
  licensePlateExamplePlaceholder: "örn. M AB 1234",
  addVehicleButton: "Araç Ekle",
  deleteVehicleModalTitle: "Araç Silinsin mi?",
  thisVehicleLabel: "Bu araç",
  willBeRemovedFromCategoryPrefix: "şu kategoriden kalıcı olarak kaldırılacak:",
  willBeRemovedFromCategorySuffix: ".",
  deletingLabel: "Siliniyor…",
  // Türkçe (tr.js)
  fileTooLargeMaxAlert: "Dosya çok büyük. Maksimum: 10MB",
  addressInputPlaceholder: "Adres girin ve listeden seçin...",
  previewSuffix: "Önizleme",
  uploadSuffix: "yükle",
  removeButton: "Kaldır",
  photoUploadRecommendationHint: "Önerilen: JPG/PNG, maks. 10MB, otomatik olarak 300x600px'e küçültülür",
  addressRequiredFieldError: "Zorunlu alan – lütfen listeden bir adres seçin",
  noFieldGroupsDefined: "Alan grubu tanımlanmadı",
  fillAllRequiredAddressFieldsError: "Lütfen tüm zorunlu alanları doldurun – adres alanları için listeden bir öneri seçin.",
  readonlyLabel: "salt okunur",
  // Türkçe (tr.js)
  selectAtLeastOneRecordError: "Lütfen en az bir kayıt seçin.",
  selectOnlyOneRecordToEditError: "Lütfen düzenlemek için yalnızca bir kayıt seçin.",
  noRecordsSelectedError: "Kayıt seçilmedi.",
  actionExecutedSuccessSuffix: "başarıyla gerçekleştirildi",
  noDataAvailableLabel: "Veri yok.",
  noRecordsAvailableLabel: "Kayıt yok",
  createNewRecordTitle: "Yeni Kayıt Oluştur",
  makeSelectionTitle: "Seçim Yapın",
  affectedRecordsLabel: "Etkilenen Kayıtlar:",
  idsLabel: "ID'ler",
  filterRecordsDesc: "Kayıtları kriterlere göre filtrele",
  deselectAllLabel: "Tümünün Seçimini Kaldır",
  selectAllLabel: "Tümünü Seç",
  clearSelectionLabel: "Seçimi Temizle",
  sortedByLabel: "Sıralandı",
  filtersActiveLabel: "Filtreler aktif",
  // Türkçe (tr.js)
  addButtonLabel: "Ekle",
  // Türkçe (tr.js)
  periodAllLabel: "Tümü",
  periodTodayLabel: "Bugün",
  periodWeekLabel: "Hafta",
  periodMonthLabel: "Ay",
  periodYearLabel: "Yıl",
  transferLabel: "Havale",
  cashShortLabel: "Nakit",
  cardShortLabel: "Kart",
  canceledLabel: "İptal Edildi",
  balanceLoadError: "Bakiye yüklenemedi.",
  noWalletDataFound: "Cüzdan verisi bulunamadı.",
  partnerAccountLabel: "Partner Hesabı",
  walletTitle: "Cüzdan",
  currentBalanceLabel: "Güncel Bakiye",
  noPayableBalanceTitle: "Ödenebilir Bakiye Yok",
  payoutButton: "Para Çek",
  transactionsLabel: "İşlemler",
  searchBookingNumberPlaceholder: "Rezervasyon numarası ara",
  noResultsForPrefix: "Sonuç bulunamadı:",
  noTransactionsInPeriod: "Bu dönemde işlem yok.",
  closeAriaLabel: "Kapat",
  payoutRequestedTitle: "Para Çekme Talep Edildi",
  willBeTransferredSoonText: "kısa süre içinde kayıtlı hesaba aktarılacaktır.",
  closeButton: "Kapat",
  confirmPayoutTitle: "Para Çekmeyi Onayla",
  amountTransferredToAccountText: "Tutar aşağıdaki hesaba aktarılacaktır:",
  accountHolderLabel: "Hesap Sahibi",
  ibanLabel: "IBAN",
  bankLabel: "Banka",
  payoutAmountLabel: "Çekilecek Tutar",
  payoutTriggerErrorText: "Para çekme işlemi başlatılamadı. Lütfen tekrar deneyin.",
  requestingPayoutLabel: "Talep ediliyor…",
  payoutNowButton: "Şimdi Çek",
  //LAST UPDATE 20082026
passengerCountTitle: "Yolcu sayısı",
// Türkisch
paymentCreditCardTitle: "Kredi Kartı",
paymentCreditCardDescription: "Rezervasyon sırasında güvenli online ödeme.",
paymentPaypalTitle: "PayPal",
paymentPaypalDescription: "PayPal hesabınızla kolayca ödeyin – sonra öde veya taksitle ödeme de mümkün.",
paymentCashTitle: "Nakit Ödeme",
paymentCashDescription: "Sabit fiyatı doğrudan şoföre nakit olarak ödeyin.",
paymentCardOnTripTitle: "Araçta Kart ile Ödeme",
paymentCardOnTripDescription: "Araç içinde temassız kart ödemesi.",
paymentCustomOfferTitle: "Kendi Teklifiniz",
paymentCustomOfferDescription: "Kendi fiyatınızı önerin, partnerimiz onaylasın.",
paymentTagInstant: "Anında onaylanır",
paymentTagSSL: "SSL şifreli",
paymentTagInstallments: "Taksitli ödeme",
paymentTagPayLater: "Sonra öde",
paymentTagNoPrepay: "Ön ödeme yok",
paymentTagContactless: "Temassız",
paymentTagNegotiable: "Pazarlığa açık",
payHowItSuitsYou: "Size uyan",
payHowItSuitsYouAccent: "şekilde ödeyin.",
// Türkisch
roundTripSavingsNotice: "Gidiş-dönüş birlikte rezervasyonda %{percent} tasarruf edersiniz.",
removeReturnTrip: "Dönüş seyahatini kaldır",
selectDate: "Tarih seçin",
clockSuffix: "",
back: "Geri",
date: "Tarih",
time: "Saat",
apply: "Uygula",
pleaseChoose: "Lütfen seçin",
cityAirport: "Şehir / Havalimanı",
addReturnTrip: "Dönüş seyahati ekle",
closeForm: "Formu kapat",
transferMode: "Transfer",
flightsMode: "Uçuşlar",
slide: "Slayt",
hotline: "Yardım Hattı",
email: "E-posta",
enterStartAddressError: "Lütfen kalkış adresini girin",
selectAddressFromListError: "Lütfen listeden bir adres seçin",
enterDestinationAddressError: "Lütfen varış adresini girin",
dateRequiredError: "Tarih gerekli",
timeRequiredError: "Saat gerekli",
departureTimeMinOneHourError: "Kalkış saati en az 1 saat sonrasında olmalıdır",
returnDateRequiredError: "Dönüş tarihi gerekli",
returnTimeRequiredError: "Dönüş saati gerekli",
returnTimeMinOneHourError: "Dönüş saati en az 1 saat sonrasında olmalıdır",
services: "Ek Hizmetler",
  waitingTime: "Bekleme süresi",
  waitingTimeDescription: "Sürücü sizi daha uzun bekler – 15 dakikalık adımlarla eklenebilir.",
  pickupAdjust: "Uçuş gecikmesinde alış saati ayarı",
  pickupAdjustDescription: "Uçuşunuz gecikirse alış saatini otomatik olarak kaydırırız – sürücünüz sizi bekler.",
  waitingFreeIncluded: "{min} dk ücretsiz dahildir",
  waitingEachExtra: "her ek {min} dk {price} €",
  flightRequiredForAdjust: "Seçtiğiniz alış saati ayarı için lütfen uçuş numaranızı girin (örn. TK1234).",
  sessionExpiredTitle: "Oturum süresi doldu",
  sessionExpiredText: "Güvenlik nedeniyle oturumunuz kapatıldı. Lütfen tekrar giriş yapın – verileriniz kaybolmadı.",
  sessionExpiredButton: "Girişe git",
  flightHintTitle: "Alış saatiniz iniş saatine uyuyor mu?",
  flightHintText: "{flight} uçuşunuzun saat {landing} civarında inmesi bekleniyor – seçtiğiniz alış saati ({pickup}) bundan önce. Lütfen iniş sonrası uygun bir alış saati seçin:",
  flightHintKeep: "Alış saatini koru ({pickup})",
  flightHintChanged: "Alış saatiniz {time} olarak güncellendi.",
  flightHintReturnPrefix: "Dönüş",
  tabCancelled: "İptal edilen"
};

export default translations;
